// extracted by mini-css-extract-plugin
export default {"list":"CreateOrganizationSortedArtistsList_list__D1xCp"};